import { render } from "./WeProposeOurAppModal.vue?vue&type=template&id=1cb5727c&scoped=true&ts=true&lang=pug"
import script from "./WeProposeOurAppModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeProposeOurAppModal.vue?vue&type=script&lang=ts&setup=true"

import "./WeProposeOurAppModal.vue?vue&type=style&index=0&id=1cb5727c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb5727c"]])

export default __exports__